import React, { useState, useEffect, useContext } from 'react'
// COMPONENTS
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
// FIREBASE
import useFirebase from '../../../firebase/useFirebase'
// APP CONTEXT
import { AppContext } from '../../../App'
// SPINNER
import Spinner from '../../../components.js/elements/Spinner'

const HorairesUsersPage = () => {
    const { user } = useContext(AppContext)
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const [tokenUser, setTokenUser] = useState(localStorage.getItem('tokenUser'))
    const { readData, profil, updateData, count } = useFirebase()
 
    const [montage, setMontage] = useState(true)

    useEffect(() => {
        readData(keyUid)
        window.scrollTo(0, 0)
        setMontage(false)
    },[])

    if (montage) return <Spinner />

    return (
        <div className='container-fluid'>

            {/* HEADER RETOUR */}
            <HeaderReturn title='Horaires' link={'/homeUser/'+keyUid+'/'+tokenUser}/>

            {profil && profil.filter(p => p.id === 'profil').map(p => (
                <div key={p.id} className='mt-5 text-center'>
                    <div className='h3'>{p.nomEntreprise}</div>
                    <div className='h4 mt-4' style={{whiteSpace:'pre-line'}}>{p.horaires}</div>
                </div>
            ))}
        </div>
    )
}

export default HorairesUsersPage
